import React from 'react';
import PropTypes from 'prop-types';

const Contract = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.051 21.478h-9.64V7.82h9.64v13.658Z"
      clipRule="evenodd"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.41 15.854H3V5.41a2.41 2.41 0 1 1 2.41 2.41V6.214h2.243"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.051 7.82a2.41 2.41 0 1 0 0-4.82h-9.64M10.231 10.911h3.214M10.23 13.566h3.214M10.23 16.663h3.214M7.018 10.633l.401.402 1.607-1.607M7.018 13.846l.401.402 1.607-1.607"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21.478 20.273a1.205 1.205 0 1 1-2.41 0V8.623a1.206 1.206 0 0 1 2.41 0v11.65Z"
      clipRule="evenodd"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.067 19.317h2.41M19.068 13.566h2.41M17.462 15.454V9.428c0-.665.54-1.205 1.205-1.205h.402"
    />
  </svg>
);

Contract.propTypes = {
  color: PropTypes.string
};

export default Contract;
